<template>
  <div>
    <MDinput
      v-model="order.widthInCm"
      type="number"
      :required="false"
      :maxlength="16"
      :precision="1"
      @input="widthInput"
    >
      {{ $t('orderLine.width') }}
    </MDinput>
    <DSESwitch
      v-model="order.unequalPartsYN"
      style="margin-top:5px"
      :active-text="'orderLine.unequalParts'"
      :inactive-text="'orderLine.equalParts'"
      @input="unequalPartsInput"
    />
    <div style="padding-bottom:50px">
      <div style="width:45%;float:left">
        <MDinput
          v-model="order.finishedWidthLeftInCm"
          :disabled="!order.unequalPartsYN"
          type="number"
          :required="false"
          :maxlength="16"
          @input="leftWidthInput"
        >
          {{ $t('orderLine.widthLeft') }}
        </MDinput>
      </div>
      <div style="width:45%;float:right">
        <MDinput
          v-model="order.finishedWidthRightInCm"
          :disabled="!order.unequalPartsYN"
          type="number"
          :required="false"
          :maxlength="16"
          @input="rightWidthInput"
        >
          {{ $t('orderLine.widthRight') }}
        </MDinput>
      </div>
    </div>
    <div style="padding-bottom:60px">
      <div style="width:45%;float:left">
        <MDinput
          v-model="order.panelsLeft"
          type="number"
          :required="false"
          :maxlength="16"
          :precision="1"
          @input="emitValues"
        >
          {{ $t('orderLine.numberOfPanelsLeft') }}
        </MDinput>
      </div>
      <div style="width:45%;float:right">
        <MDinput
          v-model="order.panelsRight"
          type="number"
          :required="false"
          :maxlength="16"
          :precision="1"
          @input="emitValues"
        >
          {{ $t('orderLine.numberOfPanelsRight') }}
        </MDinput>
      </div>
    </div>
  </div>
</template>

<script>
import MDinput from '@/components/MDinput';
import DSESwitch from '@/components/DSE/Switch';

export default {
  name: 'CreatePanel',
  components: { MDinput, DSESwitch },
  props: {},
  data() {
    return {
      order: {}
    };
  },
  computed: {
    finishes() {
      return this.$store.getters['finish/loadedItems'];
    }
  },
  watch: {},
  created() {},
  methods: {
    unequalPartsInput() {
      if (this.order.widthInCm) {
        this.order.finishedWidthLeftInCm = this.order.widthInCm / 2;
        this.order.finishedWidthRightInCm = this.order.widthInCm / 2;
      } else {
        this.order.finishedWidthLeftInCm = null;
        this.order.finishedWidthRightInCm = null;
      }
      this.emitValues();
    },
    widthInput() {
      this.unequalPartsInput();
      this.emitValues();
    },
    leftWidthInput() {
      if (this.order.finishedWidthLeftInCm) {
        this.order.widthInCm = this.order.finishedWidthLeftInCm + this.order.finishedWidthRightInCm;
      } else {
        this.order.widthInCm = this.order.finishedWidthRightInCm;
      }
      this.emitValues();
      this.$forceUpdate();
    },
    rightWidthInput() {
      if (this.order.finishedWidthRightInCm) {
        this.order.widthInCm = this.order.finishedWidthLeftInCm + this.order.finishedWidthRightInCm;
      } else {
        this.order.widthInCm = this.order.finishedWidthLeftInCm;
      }
      this.emitValues();
      this.$forceUpdate();
    },
    emitValues() {
      this.$emit('input', this.order);
    }
  }
};
</script>
<style lang="scss"></style>
